if (!customElements.get('rb-navigation')) {
  customElements.define('rb-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.desktop = window.matchMedia('(min-width: 980px)');
      this.toggleButton = this.querySelector('.rb-nav__mobile-toggle');
      this.dropdowns = [...this.querySelectorAll('.rb-nav__dropdown')];
      this.trades = [...this.querySelectorAll('.rb-nav__trade')];
      this.toolGroups = [...this.querySelectorAll('.rb-nav__tool-group')];
      const setToolLayout = () => {
        this.toolGroups.forEach(group => { group.open = this.desktop.matches; });
      };
      setToolLayout();
      this.desktop.addEventListener('change', setToolLayout, options);
      const brands = this.querySelector('.rb-nav__groups--shop-by-brand');
      if (brands) {
        [...brands.children].sort((a, b) =>
          a.textContent.trim().replace(/^the\s+/i, '').localeCompare(
            b.textContent.trim().replace(/^the\s+/i, ''), 'en-GB', { sensitivity: 'base' }
          )
        ).forEach(brand => brands.appendChild(brand));
      }
      this.toggleButton.addEventListener('click', () => {
        const open = this.toggleAttribute('data-mobile-open');
        this.toggleButton.setAttribute('aria-expanded', String(open));
        if (!open) this.closeDropdowns();
      }, options);
      this.dropdowns.forEach(dropdown => {
        dropdown.addEventListener('toggle', () => {
          if (!dropdown.open) return;
          this.dropdowns.forEach(other => { if (other !== dropdown) other.open = false; });
          if (dropdown.classList.contains('rb-nav__trade-dropdown') && this.desktop.matches &&
              !this.trades.some(trade => trade.open)) this.trades[0].open = true;
          this.closest('store-header')?.classList.remove('is-out');
          if (!this.desktop.matches) {
            requestAnimationFrame(() => {
              if (!dropdown.open) return;
              const content = this.querySelector('.rb-nav__content');
              const summary = dropdown.querySelector('summary');
              content.scrollTop += summary.getBoundingClientRect().top -
                content.getBoundingClientRect().top - 12;
            });
          } else {
            const panel = dropdown.querySelector('.rb-nav__panel');
            if (panel) panel.scrollTop = 0;
          }
        }, options);
      });
      this.trades.forEach(trade => {
        trade.addEventListener('toggle', () => {
          if (trade.open && this.desktop.matches) {
            this.trades.forEach(other => { if (other !== trade) other.open = false; });
          }
        }, options);
        trade.querySelector('summary').addEventListener('keydown', event => {
          if (!this.desktop.matches || !['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.trades.indexOf(trade);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.trades.length - 1 :
            (index + (event.key === 'ArrowDown' ? 1 : -1) + this.trades.length) % this.trades.length;
          this.trades[next].open = true;
          this.trades[next].querySelector('summary').focus();
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const dropdown = event.target.closest('.rb-nav__dropdown[open]');
        if (dropdown) {
          dropdown.open = false;
          dropdown.querySelector('summary').focus();
        } else if (this.hasAttribute('data-mobile-open')) {
          this.removeAttribute('data-mobile-open');
          this.toggleButton.setAttribute('aria-expanded', 'false');
          this.toggleButton.focus();
        }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      this.desktop.addEventListener('change', () => this.closeAll(), options);
    }
    closeDropdowns() { this.dropdowns.forEach(dropdown => { dropdown.open = false; }); }
    closeAll() {
      this.closeDropdowns();
      this.removeAttribute('data-mobile-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
